import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import TopUpWalletModal from "../topuprequest/TopUpWalletModal";
import AuthorizationModal from "../authorizationModal/authorizationModal";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import MWalletFilterModal from "./MWalletFilterModal";
import CustMainWalletAuditModal from "./CustMainWalletAuditModal";
import { format, parse } from "date-fns";

const defaultFilterData = {
  userId: "",
  customerId: "",
  fromAmount: "",
  toAmount: "",
  profile: "",
  status: [],
  fromDate: "",
  toDate: "",
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};

const TopUpMainWalletReq = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const userRole = sessionStorage.getItem("userRole");
  const loggedInUserCode = sessionStorage.getItem("userCode");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [topUpReqData, setTopUpReqData] = useState([]);
  const [custData, setCustData] = useState("");
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [utrNo, setutrNo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [smsBalance, setsmsBalance] = useState("");
  const [bankName, setBankName] = useState("");
  const [columnData, setColumnData] = useState("");
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [rowData, setRowData] = useState("");
  const [auditData, setAuditData] = useState("");
  const [isModalOpenAudit, setIsModalOpenAudit] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const getInitialFilterData = () => {
    const queryParams = new URLSearchParams(location.search);
    const statusParam = queryParams.get("status");
    if (!statusParam) {
      return defaultFilterData;
    }
    const statusFromQuery = statusParam
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    return {
      ...defaultFilterData,
      status: Array.from(
        new Set([...defaultFilterData.status, ...statusFromQuery])
      ),
    };
  };

  const [filterData, setFilterData] = useState(getInitialFilterData);

  const handleReset = () => {
    setFilterData(defaultFilterData);
    fetchTopUpMainWalletReqData(1, defaultFilterData);
  };

  const openModalAudit = () => {
    setIsModalOpenAudit(true);
  };

  const closeModalAudit = () => {
    setIsModalOpenAudit(false);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  useEffect(() => {
    fetchCust();
  }, []);

  const fetchCust = () => {
    const requestBody = {
      username: loggedInUserName,
      // status: "1",
    };

    axiosPostApi(apiList.FETCH_CUSTOMER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.data) {
          const customerCode = response?.data?.data[0]?.customerCode;
          if (customerCode) {
            fetchTopUpMainWalletReqData(1);
          }
          setCustData(response?.data?.data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching retailer data:", error);
      });
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };
    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const fetchTopUpMainWalletReqData = async (
    currentPage,
    filters = filterData
  ) => {
    console.log("::filters::", filters);

    try {
      const requestBody = {
        username: loggedInUserName,
        ...filters,
        profile: filters.profile?.value || "",
        status: filters.status || [],
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_MAIN_WALLET_HISTORY}?pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setTopUpReqData(modifiedData);
        setNoData(modifiedData?.length === 0);
      } else {
        setNoData(true);
        setTopUpReqData([]);
      }
      fetchDashboardData();
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const formatIndianNumber = (value) => {
    if (!value && value !== 0) return value;
    return Number(value).toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  // const modifyStructure = (response) => {
  //   return response?.map((item, index) => ({
  //     ...item,
  //     transactionDate: item.transactionDate?.split(" ")?.[0],
  //     // id: index + 1,
  //     amount: item.amount ? `${formatIndianNumber(item.amount)}` : "-",

  //     customerNewBalance: item?.customerNewBalance
  //       ? `${formatIndianNumber(item?.customerNewBalance)}`
  //       : "-",
  //   }));
  // };

  const modifyStructure = (response) => {
    return response?.map((user, index) => {
      const transReqDate = user?.reqDate
        ? parse(user?.reqDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      return {
        ...user,
        reqDate: transReqDate
          ? [
              format(transReqDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(transReqDate, "HH:mm:ss"),
            ]
          : "",
        transactionDate: user.transactionDate?.split(" ")?.[0],

        // amount: user?.amount ? (
        //   <div style={{ textAlign: "right" }}>
        //     {formatIndianNumber(user.amount)}
        //   </div>
        // ) : (
        //   "-"
        // ),
        amount: user?.amount
          ? `\u2003\u2003${formatIndianNumber(user.amount)}\u2003\u2003`
          : "-",

        // customerNewBalance: user?.customerNewBalance ? (
        //   <div style={{ textAlign: "right" }}>
        //     {formatIndianNumber(user.customerNewBalance)}
        //   </div>
        // ) : (
        //   "-"
        // ),

        customerNewBalance: user?.customerNewBalance
          ? `\u2003\u2003${formatIndianNumber(
              user.customerNewBalance
            )}\u2003\u2003`
          : "-",
      };
    });
  };

  const topUpReqHeaders = [
    "Status",
    "Entry Date",
    // "Company Id", //admin
    // "Company Name", //admin
    "Topup Amount(₹)",
    "Wallet Balance(₹)",
    "Txn Date",
    "Company Bank Name",
    "Pay Mode",
    "UTR No/Txn No",
    "AppanTech Bank Name",
    "Remark",
    "Attachment",
  ];

  if (userRole === "ACCMK" || userRole === "ACCCH") {
    topUpReqHeaders.splice(2, 0, "User Id", "Company Id", "Company Name");
  }

  const topUpReqHeaderToKeyMap = {
    Status: "authStatus",
    "Entry Date": "reqDate",
    "User Id": "username",
    "Company Id": "customerId",
    "Company Name": "customerCompanyName",
    "Topup Amount(₹)": "amount",
    "Wallet Balance(₹)": "customerNewBalance",
    // "Wallet Balance": userRole === "CUST" ? "customerOldBalance" : "oldBalance",
    "Txn Date": "txnDate",
    "Company Bank Name": "customerBankName",
    "Pay Mode": "payMode",
    "UTR No/Txn No": "utrNo",
    "AppanTech Bank Name": "bankName",
    Remark: "adminRemark",
    Attachment: "attachment",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
    setShowAuthModal(false);
  };

  const handlerTopUpReqSMS = (id, actionType = "view") => {
    setColumnData(id);
    setModalAction(actionType === "add_partner" ? "add" : actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "add_partner") {
      setEditData({isAddingForPartner: true});
      setShowModal(true);
    } else if (actionType === "delete") {
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerId);
      setsmsBalance(id.oldSmsBalance);
      setBankName(id?.bankName);
      setShowModal(true);
    } else if (actionType === "auth") {
      if (id.customerId === loggedInUserCode) {
        CustomAlert({
          title: "Action Not Allowed",
          text: "You cannot approve your own company's transactions.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerId);
      setsmsBalance(id.oldSmsBalance);
      setBankName(id?.bankName);
      setShowModal(true);
    } else if (actionType === "modify") {
      setShowModal(true);
    } else if (actionType === "view") {
      let data = topUpReqData.find((item) => item.id === id?.id);
      if (data) {
        setEditData(data);
        setShowModal(true);
      }
    }
  };

  const authMainWalletRequest = async (authData) => {
    try {
      const payload = {
        username: loggedInUserName,
        customerCode: rowData?.customerId,
        utrNo: rowData?.utrNo,
        bankName: rowData?.bankName,
        status: authData?.approvalStatus === "reject" ? "5" : "2",
        adminRemark: authData?.remark,
      };

      const response = await axiosPostApi(
        apiList.AUTH_MAIN_WALLET_REQ,
        payload
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        authData?.approvalStatus === "reject"
          ? CustomAlert({
              title: response?.data?.message,
              icon: "info",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            })
          : CustomAlert({
              title: `Approved`,
              text: `Request submitted to checker for final authorization`,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            });
      } else {
        CustomAlert({
          title: "Failed to Accept Request",
          text:
            response.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFinalAuthorization = (authData, actionType) => {
    setModalAction(actionType);
    setShowModal(true);
    setRowData(authData);
    setColumnData(authData);
  };

  const handleAuditData = (data) => {
    setColumnData(data);
    fetchMainWalletAudit(data);
  };

  const fetchMainWalletAudit = async (custData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        id: custData?.id,
      };

      const response = await axiosPostApi(
        `${apiList.MAIN_WALLET_AUDIT_DATA}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setAuditData(response?.data?.data?.auditData);
        openModalAudit(auditData);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch audit data.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={topUpReqHeaders}
            data={topUpReqData}
            handleAction={handlerTopUpReqSMS}
            filterFields={[
              "customerId",
              "customerCompanyName",
              "customerBankName",
            ]}
            entityType="Top-up Wallet"
            headerToKeyMap={topUpReqHeaderToKeyMap}
            loading={loading}
            handleAuth={handleFinalAuthorization}
            pageDetails={pageDetails}
            noData={noData}
            currentPage={currentPage}
            pageSize={pageSizeCount}
            totalRecord={totalRecord}
            fetchNextData={fetchTopUpMainWalletReqData}
            setCurrentPage={setCurrentPage}
            openModalFilter={openModalFilter}
            handleReset={handleReset}
            filterData={filterData}
            fetchData={() => {}}
            handleAuditData={handleAuditData}
          />

          {isModalOpenFilter ? (
            <MWalletFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setTopUpReqData={setTopUpReqData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
              defaultFilterData={defaultFilterData}
            />
          ) : null}
          {
              showModal && (
                  <TopUpWalletModal
                      show={showModal}
                      handleClose={handleCloseModal}
                      editData={editData}
                      action={modalAction}
                      data={topUpReqData}
                      fetchData={fetchTopUpMainWalletReqData}
                      customerData={custData}
                      utrNo={utrNo}
                      customerName={customerName}
                      customerCode={customerCode}
                      smsBalance={smsBalance}
                      bankName={bankName}
                      columnData={columnData}
                  />)
          }
        </>
      )}
      <AuthorizationModal
        show={showAuthModal}
        handleClose={handleCloseModal}
        callApi={authMainWalletRequest}
      />
      {isModalOpenAudit ? (
        <CustMainWalletAuditModal
          show={isModalOpenAudit}
          handleClose={closeModalAudit}
          auditData={auditData}
        />
      ) : null}
    </div>
  );
};

export default TopUpMainWalletReq;
